// pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-container" style={{
      textAlign: 'center',
      padding: '5rem 2rem',
      maxWidth: '600px',
      margin: '0 auto'
    }}>
      <h1>{t('notFound.title')}</h1>
      <h2>{t('notFound.subtitle')}</h2>
      <p>{t('notFound.message')}</p>
      <div style={{ marginTop: '2rem' }}>
        <Link to="/" className="btn btn-primary">
          {t('notFound.returnHome')}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;